import { render, staticRenderFns } from "./InspectionListHighlighter.vue?vue&type=template&id=5a8bb0a5&scoped=true&"
import script from "./InspectionListHighlighter.vue?vue&type=script&lang=ts&"
export * from "./InspectionListHighlighter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8bb0a5",
  null
  
)

export default component.exports